import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ variant = 'dark' }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('es') ? 'es' : 'en';

  const toggle = () => {
    const next = current === 'en' ? 'es' : 'en';
    i18n.changeLanguage(next);
  };

  const isDark = variant === 'dark';

  return (
    <button
      onClick={toggle}
      data-testid="language-switcher"
      className={`flex items-center gap-1.5 font-medium text-xs uppercase tracking-wide px-2.5 py-1.5 rounded-sm border transition-colors ${
        isDark
          ? 'text-slate-300 hover:text-white border-slate-700 hover:border-slate-500'
          : 'text-slate-700 hover:text-slate-900 border-slate-300 hover:border-slate-500'
      }`}
      aria-label="Toggle language"
    >
      <Globe className="w-3.5 h-3.5" />
      <span>{current === 'en' ? 'EN' : 'ES'}</span>
      <span className="opacity-50">/</span>
      <span className="opacity-50">{current === 'en' ? 'ES' : 'EN'}</span>
    </button>
  );
};

export default LanguageSwitcher;
